module.exports = __webpack_public_path__ + "img/bg-case-4.6a0f2ded.png";